<template>
    <section>
        <div class="row mx-3 py-2">
            <div class="d-middle cr-pointer" @click="regresar">
                <i class="icon-left-circle f-20 text-general" />
                <img class="border br-4 obj-cover mx-2" width="36" height="36" :src="tienda.logo_mini_firmado" alt="" />
                <p class="text-general f-600 f-18 mr-4">{{ tienda.propietario_nombre }}</p>
            </div>
            <chatIconoChat class="ml-auto" :id-tienda="parseInt(this.$route.params.id_tienda)" />
        </div>
        <tabs :tabs="tabs" class="mx-3 border-bottom" />
        <router-view />
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data(){
        return {
            tabsReales:[
                { titulo: 'Información', ruta: 'admin.tiendas.inactivos.informacion' },
                { titulo: 'Abastecimiento', ruta: 'admin.tiendas.inactivos.abastecimiento' },
                { titulo: 'Métricas', ruta: 'admin.tiendas.inactivos.metricas' },
                { titulo: 'Calificaciones', ruta: 'admin.tiendas.inactivos.calificaciones' },
                { titulo: 'Clientes', ruta: 'admin.tiendas.inactivos.clientes' },
                { titulo: 'Estados', ruta: 'admin.tiendas.inactivos.estado-leechero', can: 'tab2_leecheros_estados' },
            ],
        }
    },
    computed: {
        ...mapGetters({
            tienda: 'tiendas/info_cabecera/tienda'
        }),
        tabs(){
            return this.tabsReales
        }
    },
    mounted(){
        this.info_cabecera()
    },
    methods: {
        regresar(){
            this.$router.push({ name: 'admin.tiendas.inactivos' })
        },
        async info_cabecera(){
            await this.$store.dispatch('tiendas/info_cabecera/action_info_cabecera', this.$route.params.id_tienda)
        },
    }
}
</script>

<style lang="css" scoped>
</style>
